/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";

import { Modal, Card, Table, message, Form, Button } from "antd";
import { Row, Col, Space, Spin, Flex, Checkbox } from "antd";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";

import { columns } from "./model";
import OptionService from "../../../../service/ERP/Options.service";
import { BsUiChecks } from "react-icons/bs";
import { TagItemTypes } from "../../../badge-and-tag/ERP/";

const CheckboxGroup = Checkbox.Group;

const options = [
  { value: "Packing Goods", label: "Packing Goods" },
  { value: "Finished Goods", label: "Finished Goods" },
  { value: "Work Instruction", label: "Work Instruction" },
  { value: "Raw Material", label: "Raw Material" },
  { value: "Ingredients", label: "Ingredients" },
  // { value: "Packing", label: "Packing" },
  // { value: "Packaging", label: "Packaging" },
];

export default function ModalMaterial({ show, close, values}) {
  const optionService = OptionService();
  const [form] = useForm();
  const inputRef = useRef(null);
  const [modalData, setModalData] = useState([]);
  const [modalDataWrap, setModalDataWrap] = useState([]);

  const normalizeText = (text) => (text ?? "").toString().trim().toLowerCase();

  const [openModal, setOpenModel] = useState(show);
  const [loading, setLoading] = useState(true);
  const [onLoaded, setOnLoaded] = useState(false);

  // const [rowKeySelect, setRowKeySelect] = useState([]);
  const [checkedList, setCheckedList] = useState(options.map((option) => option.value)); // Default check all options
  const [itemsTypeOption, setItemTypeOption] = useState([]);

  const checkAll = itemsTypeOption.length === checkedList.length; // ตรวจสอบว่าเลือกทั้งหมดหรือไม่
  const indeterminate =
    checkedList.length > 0 && checkedList.length < itemsTypeOption.length;

  const onChange = (list) => {
    setCheckedList([...list]);
  };

  const onCheckAllChange = (e) => {
    const all = e.target.checked ? itemsTypeOption.map((m) => m.value) : [];
    setCheckedList([...all]);
  };

  /** handle logic component */
  const handleClose = () => {
    setTimeout(() => {
      close(false);
    }, 140);

    //setTimeout( () => close(false), 200 );
  };

  const handleSearch = (value) => {
    const query = normalizeText(value);
    const typeSet = new Set(checkedList.map(normalizeText));

    const filtered = modalData.filter((d) => {
      const typeOk = typeSet.has(normalizeText(d.typename));
      if (!typeOk) return false;

      if (!query) return true;

      const code = normalizeText(d.mat_code);
      const name = normalizeText(d.mat_name);
      return code.includes(query) || name.includes(query);
    });

    setModalDataWrap(filtered);
  };

  const handleChoose = (value) => {
    values(value);
    setOpenModel(false);
  };

  /** setting initial component */
  const column = columns({ handleChoose });

  useEffect(() => {
    if (onLoaded) {
      setLoading(true);
      setTimeout(() => {
        const value = inputRef.current?.input.value;
        handleSearch(value);

        setLoading(false);
      }, 200);
    }
  }, [checkedList]);

  useEffect(() => {
    const onload = () => {
      setLoading(true);
      // alert(cuscode)
      optionService
        .optionsMaterial({ typename: checkedList })
        .then(async (res) => {
          let { data } = res.data;
          setModalData(data);
          setModalDataWrap(data);
          // console.log(modalData, data)
          // const keySelected = selected.map((m) => m.code);
          const allOptions = options.map((m) => ({
            label: <TagItemTypes data={m.value} />,
            value: m.value,
          }));
          setItemTypeOption(allOptions);
          setCheckedList([...allOptions.map(m=>m.value)]);                

        })
        .catch((err) => {
          message.error("Request error!");

          // setLoading(false);
        })
        .finally(() =>
          setTimeout(() => {
            setLoading(false);
            setOnLoaded(true);
          }, 400)
        );
    };
    if (!!openModal) {
      onload();

      // console.log("modal-packages")
    }
  }, [openModal]);

  return (
    <>
      <Modal
        open={openModal}
        title="เลือกสินค้า"
        afterClose={() => handleClose()}
        onCancel={() => setOpenModel(false)}
        maskClosable={false}
        style={{ top: 20 }}
        width={1200}
        className="modal-material"
      >
        <Spin spinning={loading}>
          <Space
            direction="vertical"
            size="middle"
            style={{ display: "flex", position: "relative" }}
          >
            <Card style={{ backgroundColor: "#f0f0f0" }}>
              <Form form={form} layout="vertical" autoComplete="off">
                <Row
                  gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                  className="m-0"
                >
                  <Col span={24}>
                    <Form.Item label="ค้นหา">
                      <Input
                        ref={inputRef}
                        suffix={<SearchOutlined />}
                        onChange={(e) => {
                          handleSearch(e.target.value);
                        }}
                        placeholder="ค้นหาชื่อ หรือ รหัส"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                  className="m-0"
                >
                  <Col span={24}>
                    <Checkbox
                      indeterminate={indeterminate}
                      onChange={onCheckAllChange}
                      checked={checkAll}
                    >
                      <TagItemTypes data={"Check All"} />
                    </Checkbox>
                    <CheckboxGroup
                      options={itemsTypeOption}
                      value={checkedList}
                      onChange={onChange}
                    />
                  </Col>
                </Row>
              </Form>
            </Card>
            <Card style={{ minHeight: "60vh" }}>
              <Table
                bordered
                dataSource={modalDataWrap}
                columns={column}
                rowKey="mat_code"
                pagination={{
                  total: modalDataWrap?.length || 0,
                  showTotal: (_, range) =>
                    `${range[0]}-${range[1]} of ${
                      modalDataWrap?.length || 0
                    } items`,
                  defaultPageSize: 10,
                  pageSizeOptions: [10,25, 35, 50, 100],
                }}
                size="small"
              />
            </Card>
          </Space>
        </Spin>
      </Modal>
    </>
  );
}
